var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto col-12"},[_c('h1',{staticClass:"mt-5 display-4 text-uppercase text-muted"},[_vm._v("No Account Selected")]),_c('p',[_c('Icon',{attrs:{"i":"spinner","spin":""}}),_vm._v("  Redirecting to "),_c('a',{attrs:{"href":"/accounts/"}},[_vm._v("Account Selector")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }